import ProfileStartJourneyBtn from '../../start-journey-btn/profile-start-journey-btn'

export default function PublicUserProfileFooter({ username }: { username: string }) {
  return (
    <div className="fixed inset-x-5 bottom-[23px] z-20 flex justify-center xs:bottom-[42px]">
      <ProfileStartJourneyBtn
        className="w-full xs:w-[250px]"
        disclaimerPosition="top"
        variant="default"
        username={username}
      />
    </div>
  )
}
